'use client';

import { c as _c } from "react/compiler-runtime";
import { VaultConfigurationLoading } from '../../VaultV2Risk/VaultConfiguration/states';
import VaultConfigurationLayout from '../../VaultV2Risk/VaultConfiguration/VaultConfiguration.layout';
import { VaultV2ApyLoading } from '../VaultV2Apy/states';
import { VaultV2ChartTotalDepositLoading } from '../VaultV2ChartTotalDeposit/states';

/** Mirrors `VaultV2Overview.server.tsx` for the vault route `loading.tsx`. */
const VaultV2OverviewLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-lg sm:gap-xl flex flex-col"><VaultConfigurationLayout><VaultConfigurationLoading /></VaultConfigurationLayout><VaultV2ChartTotalDepositLoading /><VaultV2ApyLoading /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default VaultV2OverviewLoading;